// extracted by mini-css-extract-plugin
export var contrastLow = "_2o-1";
export var externalLink = "_2o-2";
export var externalLinkIcon = "_2o-3";
export var link = "_2o-0";
export var linkLabel = "_2o-4";